import { Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { IonItem, IonLabel, IonInput } from '@ionic/angular/standalone';

@Component({
  selector: 'x-time-input',
  standalone: true,
  imports: [ReactiveFormsModule, IonItem, IonLabel, IonInput],
  templateUrl: './x-time-input.component.html',
  styleUrl: './x-time-input.component.scss',
})
export class XTimeInputComponent {
  label = input.required<string>();
  control = input.required<FormControl<string>>();
  readonly = input<boolean>(false);
  errorMessages = input<Record<string, string>>({});

  getErrorMessage(): string | null {
    const ctrl = this.control();
    if (!ctrl || !ctrl.errors || !ctrl.touched) {
      return null;
    }

    const errors = this.errorMessages();
    const errorKey = Object.keys(ctrl.errors)[0];
    return errors[errorKey] || `Invalid ${this.label().toLowerCase()}`;
  }
}
